// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".the-personal-user-avatar{display:flex;justify-content:center;align-items:center;width:100%;height:100%;background-color:#f0faff}.the-personal-user-avatar__text{color:#03a9f4;font-size:28px;line-height:28px;font-weight:700;text-transform:uppercase}.the-personal-user-avatar__text.is-small{font-size:11px;line-height:11px}", ""]);
// Exports
module.exports = exports;
